const { attributePathToString } = require('./helper');

/**
 * The list of attribute paths to ignore.
 */
const attributePathsToIgnore = [
    'metadata',
    'AND',
    'OR',
    'ALL',
    'NIN',
    'IN'
];

/**
 * Return true if attribute should be ignored and not available in the list of attributes to query.
 * Any attributes nested below this attribute are also ignored.
 */
const ignoreAttribute = (attribute) => {
    let ignore = false;
    const attributePath = attributePathToString(attribute);

    for (const path of attributePathsToIgnore) {
        if (attributePath.endsWith(path)) {
            ignore = true;
            break;
        }
    }

    return ignore;
};

module.exports = {
    attributePathsToIgnore,
    ignoreAttribute,
};
